<template>
  <div v-loading="loading"
       element-loading-text="登录中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)"
       :class="'axj_wx_cert '+stateClass"
       >
    <img v-show="!loading&&loginStatus" src="@/assets/image/common/success.png" style="height: 100%;width: 100%"/>
    <img v-show="!loading&&!loginStatus" src="@/assets/image/common/fail.png" style="height: 100%;width: 100%"/>
  </div>
</template>
<script>


import {mapActions} from 'vuex'
export default {
  name: "wx_cert",
  data(){
    return{
      wxCode:undefined,
      loading:true,
      loginStatus:true,
      stateClass:"axj_wx_cert_wt1"
    }
  },
  created() {
    let wxParam=this.$route.query
    let code=wxParam.code
    let state=wxParam.state
    if(code){
      this.wxCode=code
      this.wxLogin()
    }
    if(state=='WEB_BODY_DIALOG'){
      this.stateClass='axj_wx_cert_wt1'
    }else{
      this.stateClass='axj_wx_cert_wt2'
    }
  },
  computed:{

  },
  methods:{
    wxLogin(){
      this.$api.axjWebApi.webIndex.wxLogin({
        Code:this.wxCode
      }).then(res=>{
        window.parent.handleLogin(res)
        this.loading=false
        if(res.code==200||res.code==2003){
          this.loginStatus=true
        }else{
          this.loginStatus=false
        }
      });
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj_wx_cert_wt1{
  height: 145px;
  width: 145px;
}
.axj_wx_cert_wt2{
  height: 108px;
  width: 108px;
}
.axj_wx_cert{
  .el-icon-loading{
    font-size: 12px;
    color: #ffffff;
  }
  .el-loading-text{
    font-size: 12px;
    color: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/axj_wx_cert/index.vue